import React from 'react';

import { Helmet } from 'react-helmet';
import { makeStyles } from 'tss-react/mui';

import { useSyncAiThreadWithRoute } from './use-sync-ai-thread-with-route';

const useStyles = makeStyles()(() => ({
  chatPage: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
}));

/**
 * Full-page chat host — intentionally (almost) empty.
 *
 * The AI chat is a singleton ChatPanel that lives in the global right drawer
 * (see src/layouts/GlobalRightDrawer.tsx and its AIChatDrawerContent host).
 * On /chat routes the drawer switches to its 'maximized' variant and expands
 * over the whole content row, so the "full-page chat" the user sees is the
 * same mounted panel that docks beside documents on other routes. Rendering
 * one instance instead of a separate full-page ChatPanel is what preserves
 * scroll position, composer drafts, and playbook-run drill-in state across
 * page <-> drawer transitions, and it lets the expand/dock animation run on a
 * single component.
 *
 * This page therefore has two small jobs: publish the routed thread id to
 * aiThreadIdVar so the drawer knows which thread to show, and reserve the
 * layout space the maximized drawer covers.
 */
export function ChatPage(): JSX.Element {
  const { classes } = useStyles();
  useSyncAiThreadWithRoute();

  return (
    <>
      <Helmet>
        <title>AI Chat</title>
      </Helmet>
      <div className={classes.chatPage} />
    </>
  );
}
